export default {
  FETCHED_ALL: 'FETCHED_ALL_CONTRACTS',
  FETCHED_MULTIPLE: 'FETCHED_CONTRACTS',
  FETCHED_SINGLE: 'FETCHED_CONTRACT',
  DELETED_SINGLE: 'DELETED_CONTRACT',
};
